export default __webpack_public_path__ + "static/media/room-sweet-apar.7af979c5.jpg";